var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconName = function SvgIconName(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.68mm",
    height: "4.57mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.1 12.95",
    fill: "#717679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.84,12.84H1.28c-.34,0-.65-.19-.81-.49-.16-.3-.13-.67.07-.94l3.5-4.93L.54,1.55c-.2-.28-.22-.64-.07-.94.16-.3.47-.49.81-.49h9.56c.29,0,.57.14.74.37l3.99,5.46c.24.32.24.75,0,1.08l-3.99,5.45c-.17.23-.45.37-.73.37ZM1.45,11.84h9.34l3.93-5.36-3.95-5.41-9.31.04,3.44,4.84c.22.32.22.74,0,1.05l-3.44,4.84ZM1.28,1.11h0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconName);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-name.6a987fffb5825d3ada949e653fa456e9.svg";